export default "__VITE_ASSET__D5KFA3QL__"